<template>
  <div class="min-h-screen py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-7xl mx-auto">
      <h1 v-if="printID === undefined" class="text-4xl font-extrabold text-gray-900 text-center mb-10">
        {{ affiliate.name }}'s Affiliate Links
      </h1>
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Affiliate URL</label>
        <div class="flex">
          <input 
            :value="`${appURI}/${affiliate.short_uuid}`"
            readonly
            class="flex-grow px-3 py-2 bg-gray-50 text-gray-900 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
            :class="{ 'rounded-l-md': printID === undefined, 'rounded': printID !== undefined }"
          >
          <button
            v-if="printID === undefined"
            @click="copyToClipboard(`${appURI}/${affiliate.short_uuid}`, 'url')"
            class="px-4 py-2 bg-blue-600 text-white rounded-r-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <ClipboardIcon class="h-5 w-5" />
          </button>
        </div>
      </div>
      <div :class="{ 'grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3': printID === undefined }">
        <div 
          v-for="image in images" 
          :key="image.id" 
          :class="{ 'bg-white rounded-xl shadow-md overflow-hidden': printID === undefined }"
        >
          <div class="p-6 flex flex-col h-full">
            <img :src="image.url" alt="Digital Image" class="rounded-lg mb-4">
            <p class="text-gray-700 mb-4 flex-grow" v-html="image.description"></p>
            <div v-if="image.type === 0" class="mt-auto">
              <div v-if="printID === undefined">
                <label class="block text-sm font-medium text-gray-700 mb-1">HTML Code</label>
                <textarea 
                  :value="getImageHTML(`${appURI}/${affiliate.short_uuid}`, image.url)"
                  readonly
                  rows="3"
                  class="w-full px-3 py-2 bg-gray-50 text-gray-900 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                ></textarea>
                <div class="mt-4 flex justify-between">
                  <button 
                    @click="copyToClipboard(getImageHTML(`${appURI}/${affiliate.short_uuid}`, image.url), 'html')"
                    class="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  >
                    <ClipboardIcon class="h-5 w-5 mr-2" />
                    Copy HTML
                  </button>
                  <!-- <button 
                    @click="router.get(`/affiliates/${affiliate.short_uuid}/links/${image.id}`)"
                    class="inline-flex items-center px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                  >
                    <PrinterIcon class="h-5 w-5 mr-2" />
                    Print
                  </button> -->
                </div>
              </div>
            </div>
            <div v-if="image.type === 1" class="mt-auto">
              <button 
                @click="requestPrint(image.id)"
                class="inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
              >
                <MailIcon class="h-5 w-5 mr-2" />
                Request Print
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { usePage, router } from '@inertiajs/vue3';
import { ClipboardIcon, MailIcon } from 'lucide-vue-next';

const page = usePage();
const affiliate = computed(() => page.props.affiliate);
const appURI = computed(() => page.props.appURI);
const printID = computed(() => page.props.printID);
const images = computed(() => page.props.images.filter(image => printID.value === undefined || printID.value === image.id));

onMounted(() => {
  if (printID.value !== undefined) {
    window.addEventListener('afterprint', () => router.get(`/affiliates/${affiliate.value.short_uuid}/links`));
    window.print();
  }
});

const getImageHTML = (url, image) => {
  return `<a href="${url}" target="_blank">
  <img src="${image}" alt="Digital Image" /><br />
  ${url}
</a>`.trim();
};

const copyToClipboard = (text, type) => {
  navigator.clipboard.writeText(text).then(() => {
    alert(`${type.toUpperCase()} copied to clipboard`);
  }).catch(err => {
    console.error('Could not copy text: ', err);
  });
};

const requestPrint = (imageId) => {
  router.get(`/affiliates/${affiliate.value.short_uuid}/links/${imageId}/request-print`);
};
</script>